import { Controller } from "@hotwired/stimulus"

// Scrolls the frame into view after a turbo:frame-load event.
// Respects sticky headers via scroll-margin-top CSS property.
// Attach to a turbo-frame element and trigger `scrollOnLoad` from a link click.
// Usage:
//   turbo_frame_tag "my_frame", data: { controller: "frame-scroll" }
//   link_to ..., data: { action: "click->frame-scroll#scrollOnLoad" }
export default class extends Controller {
  static values = { offset: { type: String, default: "0px" } }

  scrollOnLoad() {
    this.element.addEventListener("turbo:frame-load", () => {
      this.element.style.scrollMarginTop = this.offsetValue
      this.element.scrollIntoView({ block: "start", behavior: "instant" })
    }, { once: true })
  }
}
